import { Flex } from "@chakra-ui/react";
import { Formik } from "formik";
import { Form } from "react-router-dom";
import { strategiesApi } from "src/api";
import {
  DepthBidAndOfferExampleType,
  DepthBidAndOfferExampleTypeV2,
  StrategyResponse,
  UpdateStrategyParams,
} from "src/api/types";
import { useExchangeInfoStore } from "src/store";
import CButton from "../CButton/CButton";
import CInput from "../CInput/CInput";
import styles from "./StrategyDetail.module.scss";
import * as Yup from "yup";
import { useExchangeAccounts } from "src/hook/useExchangeAccounts";
import CField from "src/component/CField/CField";
import { useMessage } from "src/hook/useMessage";
import CommonBidAndOfferFormV2 from "../StrategyForms/CommonDepthBidAndOfferFormV2";
import { ErrorMessage } from "src/utils/ErrorMessage";

type Props = {
  strategy: StrategyResponse<DepthBidAndOfferExampleTypeV2>;
  onUpdated?: () => void;
};

export default function BidAndOfferDetail(props: Props) {
  const { strategy, onUpdated } = props;
  const message = useMessage();
  // const accounts = useExchangeAccounts();
  const pairs = useExchangeInfoStore((state) => state.spotPairs);
  // const pair = pairs.find((pair) => pair.id === strategy.pairId);
  // const exchangeAccount = accounts.allExchangeAccounts.find((account) => account.id === strategy.exchangeAccountId);

  return (
    <Formik
      initialValues={{
        strategyName: strategy.strategyName,
        repeatIntervalMsMin: strategy.repeatIntervalMsMin,
        repeatIntervalMsMax: strategy.repeatIntervalMsMax,

        // minDiffInPrice9: strategy.preference.minDiffInPrice9,
        maxDiffInPrice9: strategy.preference.maxDiffInPrice9,
        totalBaseAmount9: strategy.preference.totalBaseAmount9,
        minLayerAmount9: strategy.preference.minLayerAmount9,
        layerNum9: strategy.preference.layerNum9,
        // targetDepth9: strategy.preference.targetDepth9,
        side9: strategy.preference.side9,
        priceFollowRate9: strategy.preference.priceFollowRate9,
        refillLimitPrice9: strategy.preference.refillLimitPrice9,
      }}
      validationSchema={Yup.object({
        strategyName: Yup.string().required("Required"),
      })}
      onSubmit={async (values) => {
        console.log("====================================");
        console.log("values", values);
        console.log("====================================");
        alert(JSON.stringify(values, null, 2));
      }}
    >
      {({ values, setFieldValue }) => {
        return (
          <Form className={styles.form}>
            <Flex width="calc(100% - 20px)" flexDirection="column" gap={2}>
              <CommonBidAndOfferFormV2 styles={styles} />
              <Flex alignItems="center" gap={2} mt={4}>
                <CButton
                  name="保存"
                  type="submit"
                  onClick={async () => {
                    const payload: UpdateStrategyParams<DepthBidAndOfferExampleTypeV2> = {
                      strategyId: strategy.id,
                      strategyName: values.strategyName,
                      preference: {
                        // minDiffInPrice9: values.minDiffInPrice9,
                        maxDiffInPrice9: values.maxDiffInPrice9,
                        totalBaseAmount9: values.totalBaseAmount9,
                        minLayerAmount9: values.minLayerAmount9,
                        layerNum9: values.layerNum9,
                        // targetDepth9: values.targetDepth9,
                        side9: values.side9,
                        priceFollowRate9: values.priceFollowRate9,
                        refillLimitPrice9: values.refillLimitPrice9,
                      },
                    };
                    try {
                      console.log("updating strategy:", strategy.strategyName, "payload:", payload);
                      await strategiesApi.updateStrategyV2(payload);
                      message.success("更新成功");
                      onUpdated && onUpdated();
                    } catch (error) {
                      message.detailedError(<ErrorMessage error={error} />);
                    }
                  }}
                />
              </Flex>
            </Flex>
          </Form>
        );
      }}
    </Formik>
  );
}
